"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStoreLocatorData = void 0;

var _client = require("@apollo/client");

var _storeLocationList = require("../store-location-list.gql");

var useStoreLocatorData = function useStoreLocatorData(isInEditor) {
  if (isInEditor) return {
    storeLocationsLoading: false,
    storeLocationsData: null
  };

  var _useQuery = (0, _client.useQuery)(_storeLocationList.GET_STORE_LOCATIONS_LIST, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }),
      storeLocationsLoading = _useQuery.loading,
      storeLocationsData = _useQuery.data;

  return {
    storeLocationsLoading: storeLocationsLoading,
    storeLocationsData: storeLocationsData
  };
};

exports.useStoreLocatorData = useStoreLocatorData;